var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Banner'),_c('News-English'),_c('div',{staticClass:"nrk",on:{"click":_vm.EnglishNews}},[_c('img',{staticClass:"xlwm",attrs:{"src":"img/lxwmE.jpg"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }